import { PortalNotices } from "@/features/portal/components/portal-notices";

/** `/portal/notices` — the client's IRS notices, read-only. */
export default function NoticesPage() {
  return <PortalNotices />;
}
